module.exports = __webpack_public_path__ + "static/img/tc07.e58eac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/tc07.png
// module id = 176
// module chunks = 0